// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bc1uOulMt8 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.bc1uOulMt8 h4 {
  line-height: 3em;
}
.bc1uOulMt8 .QanMuK2oLb {
  float: left;
  width: 100%;
}
.bc1uOulMt8 .o77BMtNR5G {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.bc1uOulMt8 .o77BMtNR5G:hover {
  cursor: pointer;
}
.bc1uOulMt8 .o77BMtNR5G:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.YnkD7xv1NI .lZfitq4DY4:focus {
  outline: none;
}
.YnkD7xv1NI .lZfitq4DY4.hg4PvG7hia.s_B1EwDFXI {
  background: #375A88;
}
.YnkD7xv1NI .lZfitq4DY4.hg4PvG7hia.s_B1EwDFXI span {
  color: #fff;
}
.YnkD7xv1NI .s_B1EwDFXI {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.YnkD7xv1NI .s_B1EwDFXI:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.YnkD7xv1NI input {
  height: 38px;
  min-width: 220px;
}
.o77BMtNR5G.Dqz342zajS {
  background: #410102;
}
.o77BMtNR5G.fcmfzTTF52 {
  background: #911318;
}
.o77BMtNR5G.FHUGBVBFsD {
  background: #D8293B;
}
.o77BMtNR5G.Tc6pJ5ys5Z {
  background: #F2373C;
}
.o77BMtNR5G._Eehfd6Nvd {
  background: #FC4448;
}
.o77BMtNR5G.vzPXlSj2FT {
  background: #ED535E;
}
.o77BMtNR5G.hzIJrtC6QU {
  background: #E34926;
}
.o77BMtNR5G.pZ6aQYRtgT {
  background: #FC562B;
}
.o77BMtNR5G.l2kcQYBxCF {
  background: #FC6722;
}
.o77BMtNR5G.eJ1B85aZBf {
  background: #FD7F24;
}
.o77BMtNR5G.CTyhh8szOF {
  background: #FD8D26;
}
.o77BMtNR5G.Ibp46GPT_P {
  background: #EC9C3E;
}
.o77BMtNR5G.H0nfFhYZPm {
  background: #0e673a;
}
.o77BMtNR5G.w1wnKCSgQD {
  background: #208740;
}
.o77BMtNR5G.fEYfURPoYH {
  background: #239718;
}
.o77BMtNR5G.uEvYennr3J {
  background: #55A84D;
}
.o77BMtNR5G.EoI6_nnRlr {
  background: #4BBE5A;
}
.o77BMtNR5G.nxXrvV84Bd {
  background: #0CCA6A;
}
.o77BMtNR5G.ral3lbNVHq {
  background: #0A3C64;
}
.o77BMtNR5G.ZERa044wIf {
  background: #0d487a;
}
.o77BMtNR5G.adiZDmww4a {
  background: #10538d;
}
.o77BMtNR5G.D2QBL2sNao {
  background: #115A99;
}
.o77BMtNR5G.CVCmmOePui {
  background: #3387E2;
}
.o77BMtNR5G.qKtG2mUEhn {
  background: #1BA9CF;
}
.o77BMtNR5G.Nv4xGHjHME {
  background: #d27c02;
}
.o77BMtNR5G.iJSfYdm1gv {
  background: #fb9402;
}
.o77BMtNR5G.YM3LfYNJsl {
  background: #FD9B30;
}
.o77BMtNR5G.t2nmmOVt7x {
  background: #FDBE2D;
}
.o77BMtNR5G.ccmo4OgrIZ {
  background: #FED831;
}
.o77BMtNR5G.VuPKn0yFmk {
  background: #FFFD38;
}
.o77BMtNR5G.eOHHmJpEOL {
  background: #2D215C;
}
.o77BMtNR5G.GHTQhX5DvW {
  background: #483C83;
}
.o77BMtNR5G.jwoziVB7Xt {
  background: #58518d;
}
.o77BMtNR5G.VTZPGwQIQl {
  background: #7068A9;
}
.o77BMtNR5G.av6N3qIIOM {
  background: #7f78b2;
}
.o77BMtNR5G.Dw182jcSj1 {
  background: #8f88bc;
}
.o77BMtNR5G.e3NBgpcB_F {
  background: #000;
}
.o77BMtNR5G.IQMn7mFER9 {
  background: #282626;
}
.o77BMtNR5G.AIJqPwQgqC {
  background: #242222;
}
.o77BMtNR5G._0NKXxId8Ow {
  background: #353838;
}
.o77BMtNR5G.r7Ea2JYNto {
  background: #666;
}
.o77BMtNR5G.OpnzGVisGs {
  background: #999;
}
.HJXmVBC39u {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.HJXmVBC39u .ASsOjm4zjK {
  display: none;
}
.dDeJZKCWx5 {
  font-size: 11px;
  line-height: 14px;
  max-width: 842px;
  margin: 24px;
}
.dDeJZKCWx5 .LgrWYRBDxc {
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 3px;
  overflow: hidden;
}
.dDeJZKCWx5 .LgrWYRBDxc .aBM9RVzCJ5 {
  text-align: center;
  height: 100%;
  width: 40px;
  background-color: #FF9D11;
  color: #fff;
}
.dDeJZKCWx5 .LgrWYRBDxc .aBM9RVzCJ5 i {
  font-size: 14px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.dDeJZKCWx5 .LgrWYRBDxc .a1oWaIV8fu {
  padding: 8px 12% 8px 12px;
  background-color: #FFEBCF;
}
.dDeJZKCWx5 .KCCYAQjCFY {
  margin: 16px 0;
}
.dDeJZKCWx5 .KCCYAQjCFY .FJ27ClRBuB {
  position: relative;
  line-height: 15px;
  margin-bottom: 12px;
}
.dDeJZKCWx5 .KCCYAQjCFY .FJ27ClRBuB .D1QpJ9afU2 {
  text-transform: uppercase;
  font-weight: bold;
}
.dDeJZKCWx5 .KCCYAQjCFY .FJ27ClRBuB .MHO67LzHuU {
  position: absolute;
  right: 0;
}
.dDeJZKCWx5 .KCCYAQjCFY .tippy-content {
  font-weight: normal;
  text-transform: initial;
}
.dDeJZKCWx5 .MuiDivider-root {
  margin: 0 -20px;
}
.dDeJZKCWx5 .rx4NSFOcqQ {
  margin-bottom: 8px;
}
.dDeJZKCWx5 .rx4NSFOcqQ i {
  font-size: 11px;
  color: black;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `bc1uOulMt8`,
	"color-row": `QanMuK2oLb`,
	"color-tile": `o77BMtNR5G`,
	"picker-component": `YnkD7xv1NI`,
	"picker-element": `lZfitq4DY4`,
	"active": `hg4PvG7hia`,
	"btn": `s_B1EwDFXI`,
	"red-1": `Dqz342zajS`,
	"red-2": `fcmfzTTF52`,
	"red-3": `FHUGBVBFsD`,
	"red-4": `Tc6pJ5ys5Z`,
	"red-5": `_Eehfd6Nvd`,
	"red-6": `vzPXlSj2FT`,
	"orange-1": `hzIJrtC6QU`,
	"orange-2": `pZ6aQYRtgT`,
	"orange-3": `l2kcQYBxCF`,
	"orange-4": `eJ1B85aZBf`,
	"orange-5": `CTyhh8szOF`,
	"orange-6": `Ibp46GPT_P`,
	"green-1": `H0nfFhYZPm`,
	"green-2": `w1wnKCSgQD`,
	"green-3": `fEYfURPoYH`,
	"green-4": `uEvYennr3J`,
	"green-5": `EoI6_nnRlr`,
	"green-6": `nxXrvV84Bd`,
	"blue-1": `ral3lbNVHq`,
	"blue-2": `ZERa044wIf`,
	"blue-3": `adiZDmww4a`,
	"blue-4": `D2QBL2sNao`,
	"blue-5": `CVCmmOePui`,
	"blue-6": `qKtG2mUEhn`,
	"yellow-1": `Nv4xGHjHME`,
	"yellow-2": `iJSfYdm1gv`,
	"yellow-3": `YM3LfYNJsl`,
	"yellow-4": `t2nmmOVt7x`,
	"yellow-5": `ccmo4OgrIZ`,
	"yellow-6": `VuPKn0yFmk`,
	"purple-1": `eOHHmJpEOL`,
	"purple-2": `GHTQhX5DvW`,
	"purple-3": `jwoziVB7Xt`,
	"purple-4": `VTZPGwQIQl`,
	"purple-5": `av6N3qIIOM`,
	"purple-6": `Dw182jcSj1`,
	"black-1": `e3NBgpcB_F`,
	"black-2": `IQMn7mFER9`,
	"black-3": `AIJqPwQgqC`,
	"black-4": `_0NKXxId8Ow`,
	"black-5": `r7Ea2JYNto`,
	"black-6": `OpnzGVisGs`,
	"picker-theme": `HJXmVBC39u`,
	"arrow-regular": `ASsOjm4zjK`,
	"search-template__root": `dDeJZKCWx5`,
	"search-template__warning": `LgrWYRBDxc`,
	"warning-icon": `aBM9RVzCJ5`,
	"warning-message": `a1oWaIV8fu`,
	"select-template__root": `KCCYAQjCFY`,
	"select-template__info": `FJ27ClRBuB`,
	"info-template__label": `D1QpJ9afU2`,
	"info-template__required": `MHO67LzHuU`,
	"select-template__label": `rx4NSFOcqQ`
};
export default ___CSS_LOADER_EXPORT___;
